import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

function PageViewModal({
  simpleViewCurrent,
  providerSummaryViewCurrent,
  fullViewCurrent,
  datesViewCurrent,
  summaryViewCurrent,
  defFullViewCurrent,
  savePrefrenceCallback,
  setHomeData,
}) {
  const { register, setValue, watch } = useFormContext();

  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedDefendant, setSelectedDefendant] = useState(null);

  useEffect(() => {
    if (simpleViewCurrent) {
      setSelectedProvider("simple");
      setValue("ProviderSimple", true);
      setValue("ProviderFull", false);
      setValue("ProviderDates", false);
      setValue("ProviderSummary", false);
    } else if (providerSummaryViewCurrent) {
      setSelectedProvider("psummary");
      setValue("ProviderSimple", false);
      setValue("ProviderFull", false);
      setValue("ProviderDates", false);
      setValue("ProviderSummary", true);
    } else if (fullViewCurrent) {
      setSelectedProvider("full");
      setValue("ProviderFull", true);
      setValue("ProviderSimple", false);
      setValue("ProviderDates", false);
      setValue("ProviderSummary", false);
    } else if (datesViewCurrent) {
      setSelectedProvider("dates");
      setValue("ProviderDates", true);
      setValue("ProviderSimple", false);
      setValue("ProviderFull", false);
      setValue("ProviderSummary", false);
    }

    if (summaryViewCurrent) {
      setSelectedDefendant("summary");
      setValue("DefSummary", true);
      setValue("DefFull", false);
    } else if (defFullViewCurrent) {
      setSelectedDefendant("full");
      setValue("DefFull", true);
      setValue("DefSummary", false);
    }
  }, [
    simpleViewCurrent,
    providerSummaryViewCurrent,
    fullViewCurrent,
    datesViewCurrent,
    summaryViewCurrent,
    defFullViewCurrent,
    setValue,
  ]);

  const handleProviderChange = (view) => {
    setSelectedProvider(view);
    setValue("ProviderSimple", view === "simple");
    setValue("ProviderSummary", view === "psummary");
    setValue("ProviderFull", view === "full");
    setValue("ProviderDates", view === "dates");

    setTimeout(() => {
      const updatedValues = watch();
      savePrefrenceCallback(updatedValues);
    }, 0);
  };

  const handleDefendantChange = (view) => {
    setSelectedDefendant(view);
    setValue("DefSummary", view === "summary");
    setValue("DefFull", view === "full");

    setTimeout(() => {
      const updatedValues = watch();
      savePrefrenceCallback(updatedValues);
      setHomeData(updatedValues);
    }, 0);
  };

  return (
    <>
      <div
        className="two-radio-groups"
        style={{
          // height: "260px",
          scrollbarWidth: "none",
        }}
      >
        <div
          className="d-flex align-items-start justify-content-evenly"
          style={{ padding: "0px", gap: "10px", height: "max-content" }}
        >
          <div className="d-flex radio-buttons">
            <div className="radio-group" style={{ gap: "0px" }}>
              <h4>Provider</h4>
              <div
                className={"d-flex align-items-center gap-1 ps-0 height-35 "}
                onClick={() => handleProviderChange("simple")}
              >
                <input
                  type="radio"
                  value="simple"
                  {...register("ProviderSimple")}
                  className="radio-input"
                />
                <div className={`radio-circle ${selectedProvider === "simple" ? "checked" : ""}`} />
                <span>Simple View</span>
              </div>

              <div
                className={"d-flex align-items-center gap-1 ps-0 height-35"}
                onClick={() => handleProviderChange("psummary")}
              >
                <input
                  type="radio"
                  value="psummary"
                  {...register("ProviderSummary")}
                  className="radio-input"
                />
                <div
                  className={`radio-circle ${selectedProvider === "psummary" ? "checked" : ""}`}
                />
                <span>Summary View</span>
              </div>

              <div
                className={"d-flex align-items-center gap-1 ps-0 height-35"}
                onClick={() => handleProviderChange("full")}
              >
                <input
                  type="radio"
                  value="full"
                  {...register("ProviderFull")}
                  className="radio-input"
                />
                <div className={`radio-circle ${selectedProvider === "full" ? "checked" : ""}`} />
                <span>Full View</span>
              </div>

              <div
                className={"d-flex align-items-center gap-1 ps-0 height-35"}
                onClick={() => handleProviderChange("dates")}
              >
                <input
                  type="radio"
                  value="dates"
                  {...register("ProviderDates")}
                  className="radio-input"
                />
                <div className={`radio-circle ${selectedProvider === "dates" ? "checked" : ""}`} />
                <span>Dates View</span>
              </div>
            </div>
          </div>

          <div className="d-flex radio-buttons">
            <div className="radio-group" style={{ gap: "0px" }}>
              <h4>Defendant Page</h4>
              <div
                className={"d-flex align-items-center gap-1 ps-0 height-35"}
                onClick={() => handleDefendantChange("summary")}
              >
                <input
                  type="radio"
                  value="summary"
                  {...register("DefSummary")}
                  className="radio-input"
                />
                <div
                  className={`radio-circle ${selectedDefendant === "summary" ? "checked" : ""}`}
                />
                <span>Summary View</span>
              </div>

              <div
                className={"d-flex align-items-center gap-1 ps-0 height-35  "}
                onClick={() => handleDefendantChange("full")}
              >
                <input type="radio" value="full" {...register("DefFull")} className="radio-input" />
                <div className={`radio-circle ${selectedDefendant === "full" ? "checked" : ""}`} />
                <span>Full View</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PageViewModal;
